import { Injectable } from '@angular/core';
import { CanMatch } from '@angular/router';

import { AppError, ErrorTypes } from '@app/entities/models/error/error.model';
import { isIOS, isAndroid } from '@shared/utils/is-tablet.util';

import { ErrorService } from '../error/error.service';

@Injectable({
  providedIn: 'root'
})
export class PlatformGuardService implements CanMatch {
  // eslint-disable-next-line @typescript-eslint/no-deprecated
  agent = navigator.userAgent || navigator.vendor;
  constructor(private errorService: ErrorService) {}

  async canMatch(): Promise<boolean> {
    if (isIOS(this.agent) || isAndroid(this.agent)) {
      return true;
    }

    const message = 'Unable to open page due to incorrect platform';
    this.errorService.add(
      new AppError(ErrorTypes.FORBIDDEN, message, {
        hash: location.hash
      })
    );
    return false;
  }
}
